import React from 'react';
import { Link } from 'react-router-dom';

// Sample data for coffee sources
const coffeeSources = [
  {
    title: 'Cereals and Pulses',

    name: 'Mung Beans',
    pronunciation: 'Mung Beenz', // Standard English pronunciation
    description:
      'A highly nutritious pulse, with a mild, sweet flavor. Rich in protein and fiber, and used in a variety of dishes, including soups, stews, and sprouted salads. Important as a emerging crop within the Ethiopian agriculture sector',
    image: './assets/images/products/Mung-Beans.jpg',
  },
  {
    name: 'Teff',
    pronunciation: 'Teff',
    description:
      "The 'Queen of Grains,' naturally gluten-free and nutrient-rich. Available in white, brown, and mixed varieties. Essential for injera, porridge, and healthy baking",
    image: './assets/images/products/teff.jpg',
  },
  {
    name: 'Barley', 
    pronunciation: 'Bar-ley',
    description:
      'A robust grain, high in fiber and with a nutty flavor. Offered as whole grain, pearled, or flour. Ideal for traditional stews, soups, and hearty breads',
    image: './assets/images/products/barele.jpeg',
  },
  {
    name: 'Wheat',
    pronunciation: 'Weet',
    description:
      'High quality wheat, that is a staple food in Ethiopia. We provide different varieties of wheat, that is suitable for baking, and other food products',
    image: './assets/images/products/wheat.jpeg',
  },
  {
    name: 'Maize (Corn)',
    pronunciation: 'Mayz',
    description:
      'A versatile staple, available as whole kernels, flour, and grits. Used in a variety of traditional and contemporary dishes, from porridge to breads',
    image: './assets/images/products/corn.webp',
  },
  {
    name: 'Chickpeas',
    pronunciation: 'Chik-peez',
    description:
      'A protein-rich pulse, with a creamy texture. Available in various sizes and colors, perfect for stews, salads, and hummus',
    image: './assets/images/products/cheakpeas.jpeg',
  },
  {
    name: 'Lentils',
    pronunciation: 'Len-tils',
    description:
      'A staple source of protein and fiber. Available in red, green, and brown varieties. Used in a wide range of traditional and international dishes.',
    image: './assets/images/products/linties.jpeg',
  },
  {
    name: 'Haricot Beans',
    pronunciation: 'Ha-ri-ko Beenz',
    description:
      'A creamy and versatile bean, rich in nutrients. Ideal for stews, soups, and side dishes. Available in different sizes, and colors',
    image: './assets/images/products/Haricot Beans.webp',
  },
  {
    name: 'Fava Beans',
    pronunciation: 'Gu-ji',
    description:
      'A hearty and nutritious bean, with a distinctive flavor. Used in traditional Ethiopian dishes and international cuisine',
    image: './assets/images/products/oilseeds.webp',
  },
  {
    name: 'Mung Beans',
    pronunciation: 'Gu-ji',
    description:
      'A highly nutritious pulse, with a mild, sweet flavor. Rich in protein and fiber, and used in a variety of dishes, including soups, stews, and sprouted salads. Important as a emerging crop within the Ethiopian agriculture sector',
    image: './assets/images/products/oilseeds.webp',
  },
  {
    name: 'Soybeans',
    pronunciation: 'Gu-ji',
    description:
      'A highly versatile and protein-rich legume. Used for oil extraction, food products (tofu, soy milk), and animal feed. A growing and important crop within the Ethiopian agriculture sector',
    image: './assets/images/products/oilseeds.webp',
  },
];

const Products = () => {
  return (
    <section className="relative py-24 bg-gradient-to-b from-emerald-50 to-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-20">
          <h2 className="text-6xl font-bold bg-gradient-to-r from-emerald-600 to-emerald-400 bg-clip-text text-transparent">
            Our Products
          </h2>
          <div className="w-24 h-1 bg-emerald-500 mx-auto mt-4 mb-8 rounded-full"></div>
          <h3 className="text-2xl text-emerald-800 font-light">
            Cereals and Pulses
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {coffeeSources.slice(0, 8).map((product, index) => (
            <div 
              key={index}
              className="group relative bg-white rounded-3xl p-6 transition-all duration-500 hover:shadow-2xl hover:shadow-emerald-100"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              <div className="relative">
                <div className="mb-6 overflow-hidden rounded-2xl">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-48 object-cover transform group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                
                <h4 className="text-2xl font-semibold text-gray-800 mb-2">
                  {product.name}
                </h4>
                
                <p className="text-emerald-600 font-medium mb-4 italic">
                  {product.pronunciation}
                </p>
                
                <p className="text-gray-600 leading-relaxed">
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link
            to="/product"
            className="inline-flex items-center px-8 py-4 text-lg font-medium text-white bg-emerald-600 rounded-full hover:bg-emerald-700 transition-colors duration-300 group"
          >
            <span>Explore All Products</span>
            <svg
              className="ml-2 w-6 h-6 transform group-hover:translate-x-2 transition-transform duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Products;